import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CommonAppointmentCalendar from "./CommonAppointmentCalendar";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { fetchAppointmentsLeadAction } from "../../../store/actions/AppointmentActions";
import Swal from "sweetalert2";

export const ServiceCallerAppointmentCalendar = ({
  leadId,
  patientId,
  doctorId,
}) => {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(null);
  
  // ✅ Safe selector

  const { bookedAppointments = [] } = useSelector(
    (state) => state.appointmentState || {}
  );
  // ✅ Fetch appointments
  useEffect(() => {
    if (patientId) {
      dispatch(fetchAppointmentsLeadAction(leadId, patientId));
    } else if (leadId) {
      dispatch(fetchAppointmentsLeadAction(leadId, null));
    }
  }, [leadId, patientId, dispatch]);

  // ✅ Check if there's a pending payment appointment
  // const hasPendingPaymentAppointment = () => {
  //   const pendingAppointment = appointments.find(
  //     (appt) => 
  //       appt.is_payment === "No" && 
  //       appt.appointment_status?.toLowerCase() !== "cancel" &&
  //       appt.appointment_status?.toLowerCase() !== "cancelled"
  //   );
  //   return !!pendingAppointment;
  // };

  // ✅ Check if appointment already exists (not cancelled)
  // const hasAppointment = appointments.some(
  //   (a) => 
  //     (String(a.lead_id) === String(leadId) || String(a.patient_id) === String(patientId)) &&
  //     a.appointment_status?.toLowerCase() !== "cancel" &&
  //     a.appointment_status?.toLowerCase() !== "cancelled"
  // );

  return (
    <div>
           {/* Booking UI */}
           <div
  className="card border-0 shadow-sm shadow-none"
  style={{
    borderRadius: "14px",
  }}
>
  <div className="card-body p-3">

    <div className="d-flex align-items-end flex-wrap gap-3">

      {/* Date Picker */}
      <div style={{ minWidth: "260px" }}>

        <label
          className="form-label fw-semibold mb-2"
          style={{
            fontSize: "15px",
            color: "#343a40",
          }}
        >
          Select Preferred Date
        </label>

        <div className="position-relative">

          {/* Calendar Icon */}
          <i
            className="fa fa-calendar position-absolute"
            style={{
              left: "14px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "16px",
              color: "#6c757d",
              zIndex: 10,
              pointerEvents: "none",
            }}
          />

          <DatePicker
            selected={selectedDate}
            onChange={(date) =>
              setSelectedDate(date)
            }
            minDate={new Date()}
            dateFormat="dd/MM/yyyy"
            placeholderText="DD/MM/YYYY"
            showPopperArrow={false}
            popperPlacement="bottom-start"
            className="form-control telecaller-date-input"
            wrapperClassName="w-100"
          />

          {/* Clear Icon */}
          {selectedDate && (
            <i
              className="fa fa-times-circle position-absolute"
              onClick={() =>
                setSelectedDate(null)
              }
              style={{
                right: "14px",
                top: "50%",
                transform:
                  "translateY(-50%)",
                fontSize: "18px",
                cursor: "pointer",
                zIndex: 10,
                color: "#6c757d",
              }}
            />
          )}

        </div>
      </div>

      {/* Confirm Button */}
      <div>

        <button
          className="btn btn-primary d-flex align-items-center justify-content-center"
          style={{
            height: "50px",
            borderRadius: "10px",
            fontWeight: "600",
            fontSize: "15px",
            whiteSpace: "nowrap",
            minWidth: "120px",
            marginTop: "30px",
          }}
          onClick={() => {

            if (!selectedDate) {
              Swal.fire({
                icon: "warning",
                title: "Select Date",
                text: "Please select a date",
              });

              return;
            }

            // Prevent booking during reschedule
            if (window.isRescheduling) {
              return;
            }

            window.dispatchEvent(
              new CustomEvent(
                "serviceCallerBookClick",
                {
                  detail: {
                    selectedDate,
                  },
                }
              )
            );
          }}
        >
          Confirm
        </button>

      </div>

    </div>

  </div>

  {/* Custom Styling */}
  <style>
    {`
      .react-datepicker-wrapper {
        width: 100%;
      }

      .telecaller-date-input {
        width: 260px !important;
        height: 50px !important;
        border-radius: 10px !important;
        border: 1px solid #ced4da !important;
        padding-left: 42px !important;
        padding-right: 42px !important;
        font-size: 15px !important;
        transition: all 0.2s ease;
      }

      .telecaller-date-input:focus {
        border-color: #0d6efd !important;
        box-shadow: 0 0 0 0.15rem rgba(13,110,253,.15) !important;
        outline: none !important;
      }

      @media (max-width: 768px) {

        .telecaller-date-input {
          width: 100% !important;
          height: 46px !important;
          font-size: 14px !important;
        }

        .btn {
          width: 100%;
          height: 46px !important;
          font-size: 14px !important;
          margin-top: 10px !important;
        }

        .d-flex {
          width: 100%;
        }
      }
    `}
  </style>

</div>
      {/* Calendar always visible */}
      <CommonAppointmentCalendar
        leadId={leadId}
        patientId={patientId}
        doctorId={doctorId}
        currentLeadId={leadId}
        currentPatientId={patientId}
        module="service_caller"
        appointmentType="service_caller"
        selectedDate={selectedDate}
        openFromServiceCaller={true}
      />

      {/* Hide booking UI if appointment already exists OR has pending payment */}
      {/* {!hasAppointment && !hasPendingPaymentAppointment() && ( */}
   
      {/* )} */}

      {/* Show pending payment warning if exists */}
      {/* {hasPendingPaymentAppointment() && (
        <div className="alert alert-warning mt-3" role="alert">
          <i className="fas fa-exclamation-triangle me-2"></i>
          <strong>Payment Required:</strong> You have an existing appointment with pending payment. Please complete the payment before booking a new appointment.
        </div>
      )} */}
    </div>
  );
};

ServiceCallerAppointmentCalendar.propTypes = {
  leadId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  patientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  doctorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ServiceCallerAppointmentCalendar;
